import { coordinate, CoordinateType } from '@/hook/useTransform'
import { computed } from 'vue'
import { ui18n } from '@/lang'
import { main } from '@/store/dataset'
import {} from '@/store/setup'

export const CoordOptions = []

export const coordTypes = {
  [CoordinateType.GIS]: {
    label: ui18n.t('coord.types.gis'),
    options: computed(() => {
      return coordinate[CoordinateType.GIS].filter(item =>
        main.value.gfw ? item.label !== 'WGS-84' : item.label !== 'CGCS2000'
      )
    })
  },
  [CoordinateType.PRO]: {
    label: ui18n.t('coord.types.pro'),
    options: computed(() => coordinate[CoordinateType.PRO])
    // options: computed(() => coordinate[CoordinateType.PRO].filter(item => item.gfw === main.value.gfw)),
  }
}
